// @flow

import React, { Component } from "react";

import ToggleButton from "../../toggle-button";
import type { RadioWidget as RadioWidgetProps } from "react-jsonschema-form/lib/components/widgets/RadioWidget";
import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";

type Props = $Exact<{
  ...RadioWidgetProps,
  options: Object,
}>;

class ToggleWidget extends Component<Props> {
  get items() {
    const enumOptions = this.props.options.labels || this.props.options.enumOptions;

    return enumOptions.map(option => ({
      label: option.label
        ? option.label.charAt(0).toUpperCase() + option.label.substring(1, option.label.length)
        : null,
      value: option.value,
      active:
        this.props.value === undefined || this.props.value === null
          ? this.props.value
          : this.props.value === option.value,
    }));
  }

  render() {
    return (
      <React.Fragment>
        <ToggleButton
          initialValue={this.props.value}
          items={this.items}
          onChange={this.props.onChange}
          disabled={this.props.options.disabled}
        />
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default ToggleWidget;
